
import { appApi } from '../../../store/app.api';
import { appEndpoint } from '../../../store/app.endpoint';
import { CommandRequest } from '../../../libs/auth/utilities/command-request';

export const newsletterApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    getSubscribers: build.query<any, void>({
      query: () => ({
        url: appEndpoint.subscribers,
        method: 'get',
      }),
      providesTags: ['Subscribers'],
    }),

    addNewsletter: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: appEndpoint.newsLetters,
        method: 'post',
        data: data.body
      }),
        invalidatesTags: (result) => (result ? ["Newsletter"] : []),
    }),
    sendNewsletter: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.sendNewsletter}/${data.id}`,
        method: 'post',
        data: data.body
      }),
        invalidatesTags: (result) => (result ? ["Newsletter"] : []),
    }),

    getNewsletters: build.query<any, void>({
      query: () => ({
        url:  appEndpoint.newsLetters,
        method: 'get',
      }),
      providesTags: ['Newsletter'],
    }),

    updateNewsletter: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.newsLetters}/${data.id}`,
        method: 'put',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["Newsletter"] : []),
    }),

    getNewsletterById: build.query<any, string>({
      query: (id) => ({
        url: `${appEndpoint.newsLetters}/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [{ type: 'Newsletter', id }],
    }),

    deleteNewsletter: build.mutation<void, string>({
      query: (id) => ({
        url: `${appEndpoint.newsLetters}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['Newsletter'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetSubscribersQuery,
  useGetNewslettersQuery,
  useGetNewsletterByIdQuery,
  useAddNewsletterMutation,
  useUpdateNewsletterMutation,
  useDeleteNewsletterMutation,
  useSendNewsletterMutation
} = newsletterApi;